import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { incrementPostLikeCount } from '../../actions/increment-post-like-count';
import { MODAL_TYPE_SHARE_POST } from '../../constants/modal-types';
import { openModal } from '../../actions/open-modal';
import PostMainActions from '../../components/post-main-actions';

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      onShareClick: () =>
        openModal(MODAL_TYPE_SHARE_POST, {
          categoryId: ownProps.category._id,
          categorySlug: ownProps.category.slug,
          postId: ownProps.post._id,
          postSlug: ownProps.post.slug,
        }),
      onLikeClick: () => incrementPostLikeCount(ownProps.post._id),
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(PostMainActions);



// WEBPACK FOOTER //
// ./app/containers/post-main-actions/post-main-actions.js